import type { Components, Theme } from "@mui/material";

export const alertTheme: Components<Theme>["MuiAlert"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.main,
      borderRadius: theme.borderRadius.md,
      padding: theme.spacing(1, 2),
      [theme.breakpoints.down("sm")]: {
        flexWrap: "wrap",
      },
    }),
    action: ({ theme }) => ({
      padding: theme.spacing(0, 0, 0, 2),
      marginRight: 0,
    }),
    standardInfo: ({ theme }) => ({
      backgroundColor: theme.palette.info.light,
      border: `1px solid ${theme.palette.info.main}`,
      "& .MuiAlert-icon": {
        color: theme.palette.custom.iconInfo,
      },
    }),
    standardSuccess: ({ theme }) => ({
      backgroundColor: theme.palette.success.light,
      border: `1px solid ${theme.palette.custom.borderSecondarySuccess}`,
      "& .MuiAlert-icon": {
        color: theme.palette.custom.iconSuccess,
      },
    }),
    standardWarning: ({ theme }) => ({
      backgroundColor: theme.palette.warning.light,
      border: `1px solid ${theme.palette.custom.borderSecondaryWarning}`,
      "& .MuiAlert-icon": {
        color: theme.palette.custom.iconWarning,
      },
    }),
    standardError: ({ theme }) => ({
      backgroundColor: theme.palette.error.light,
      border: `1px solid ${theme.palette.custom.borderSecondaryError}`,
      "& .MuiAlert-icon": {
        color: theme.palette.custom.iconError,
      },
    }),
  },
};
